import React from 'react'
import { useTranslate } from '@/utils/translate/translate-client'
import { HlsTooltip } from './HlsTooltip'

/** Subtitles icon — Bitmovin subtitles.svg (32x32 viewBox, speech bubble with caption bars). */
const SubtitlesIcon: React.FC = () => (
  <svg width={24} height={24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#fff"
      d="M19.74 26.6l-3.56-3.14h-11a2.77 2.77 0 01-2.64-2.87V8.15A2.74 2.74 0 015.22 5.3H26.79a2.75 2.75 0 012.63 2.85V20.57a2.76 2.76 0 01-2.63 2.85H23.06zM4.89 7.7V21.14h12l2.82 2.63 2.54-2.65H27V7.7z"
    />
    <path
      fill="#fff"
      d="M7.48 15.78H12a.89.89 0 01.92.86v1.85a.89.89 0 01-.92.86H7.48a.89.89 0 01-.92-.86V16.64a.89.89 0 01.92-.86z"
    />
    <path
      fill="#fff"
      d="M15.07 15.78h5a.88.88 0 01.91.86v1.85a.89.89 0 01-.91.86h-5a.89.89 0 01-.92-.86V16.64a.89.89 0 01.92-.86z"
    />
    <path
      fill="#fff"
      d="M23 15.78h1.08a.89.89 0 01.92.86l0 1.85a.89.89 0 01-.91.86H23.06a.89.89 0 01-.91-.86V16.64a.86.86 0 01.85-.86z"
    />
  </svg>
)

interface HlsSubtitleButtonProps {
  onOpenSubtitles: () => void
}

/**
 * Dedicated Subtitles button for the HLS.js player control bar.
 * Only rendered when 2+ subtitle tracks are available.
 * Opens the settings panel directly to the subtitles sub-page.
 */
export const HlsSubtitleButton: React.FC<HlsSubtitleButtonProps> = ({ onOpenSubtitles }) => {
  const { t } = useTranslate('common')

  return (
    <button
      type="button"
      data-hls-settings-trigger
      className="group relative flex h-9 w-9 items-center justify-center rounded-full transition-colors hover:bg-white/20"
      onClick={onOpenSubtitles}
      aria-label={t('subtitles', 'Subtitles')}
    >
      <SubtitlesIcon />
      <HlsTooltip
        title={t('subtitles', 'Subtitles')}
        subtitle={t('subtitlesDescription', 'Choose your preferred language.')}
      />
    </button>
  )
}
